import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';
import { IAvailabilitySlot } from '../models/appointment.model';

@Injectable({providedIn: 'root'})
export class CoachCalendarService {

  private apiPrefix = '/coach';

  constructor(
    private api: ApiService,
  ) {
  }

  getSettings(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/settings`);
  }

  getAvailability(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/availability`);
  }

  /** Replaces every slot the coach has — the API knows no partial update. */
  setAvailability(slots: IAvailabilitySlot[]): Observable<any> {
    return this.api.put(`${this.apiPrefix}/availability`, {slots});
  }

  /** Without a range the API returns every appointment. */
  getAppointments(from?: Date, to?: Date): Observable<any> {
    const queryString = (from && to)
      ? `?from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`
      : '';

    return this.api.get(`${this.apiPrefix}/appointments`, queryString);
  }

  /** Bookable starts inside the coach's availability, with the taken ones already removed. */
  getFreeSlots(from: Date, to: Date): Observable<any> {
    const queryString = `?from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`;
    return this.api.get(`${this.apiPrefix}/appointments/free-slots`, queryString);
  }

  createAppointment(data: { studentId: number, title: string, startsAt: string, notes?: string }): Observable<any> {
    return this.api.post(`${this.apiPrefix}/appointments`, data);
  }

  /** Moving keeps the Meet link and notifies the student. */
  moveAppointment(appointmentId: number, startsAt: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/appointments/${appointmentId}/schedule`, {startsAt});
  }

  cancelAppointment(appointmentId: number, reason?: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/appointments/${appointmentId}/cancel`, {reason});
  }

  getWeeklyStatus(studentId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/appointments/weekly-status`, `?studentId=${studentId}`);
  }

  getIntroMeetings(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/intro-meetings`);
  }

  getRescheduleRequests(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/appointments/reschedule-requests`, queryString);
  }

  approveRescheduleRequest(requestId: number): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/appointments/reschedule-requests/${requestId}/approve`, {});
  }

  rejectRescheduleRequest(requestId: number, note?: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/appointments/reschedule-requests/${requestId}/reject`, {note});
  }
}
